export default __webpack_public_path__ + "static/robust-74bf53e529ce78ce976083b1fda669c8.webp";